import { computed } from 'vue'

import { StatsLevel, YesNoEnum } from '@collector/sportsapi-client-legacy'

import { useCompetition } from './useCompetition'

export const useSeason = () => {
  const { competition } = useCompetition()
  const season = computed(() => competition.value.season)

  const isSeasonStatsLevel = (...statsLevel: StatsLevel[]) =>
    statsLevel.includes(season.value.stats_lvl)

  const isPlayerSearchAllowed = () => {
    if (isSeasonStatsLevel(StatsLevel.Bronze, StatsLevel.Silver))
      return season.value.manual_missing_lineup_creation === YesNoEnum.Yes
    else return true
  }

  return {
    season,
    isSeasonStatsLevel,
    isPlayerSearchAllowed,
  }
}
